import Marionette from 'backbone.marionette';
import Navigator from '../../app';
import ErrorController from './error_controller';
var API = {
  showError: function () {
    ErrorController.showError();
  }
};
Navigator.vent.on("fail", function () {
  console.log('fail trigger');
  API.showError();
});